var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.88889 6.3L4.33333 6.3L4.33333 7.7L2.88889 7.7L2.88889 6.3ZM13 2.8L13 12.6C13 13.37 12.35 14 11.5556 14L1.44444 14C0.642778 14 -8.1202e-08 13.37 -7.65255e-08 12.6L0.0072222 2.8C0.0072222 2.03 0.642778 1.4 1.44444 1.4L2.16667 1.4L2.16667 1.31591e-08L3.61111 2.19319e-08L3.61111 1.4L9.38889 1.4L9.38889 5.70229e-08L10.8333 6.57957e-08L10.8333 1.4L11.5556 1.4C12.35 1.4 13 2.03 13 2.8ZM1.44444 4.2L11.5556 4.2L11.5556 2.8L1.44444 2.8L1.44444 4.2ZM11.5556 12.6L11.5556 5.6L1.44444 5.6L1.44444 12.6L11.5556 12.6ZM8.66667 7.7L10.1111 7.7L10.1111 6.3L8.66667 6.3L8.66667 7.7ZM5.77778 7.7L7.22222 7.7L7.22222 6.3L5.77778 6.3L5.77778 7.7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCalendar);
export default __webpack_public_path__ + "static/media/dashboard-calendar.7572e6d6d74bf22b930148f20c42b5a3.svg";
export { ForwardRef as ReactComponent };